import { useState, useCallback } from "react";
import { useNotification } from "./useNotification";
import {
  JOURNALIST_COURSE_STATUS,
  PAGINATION_DEFAULTS,
  RECORDS_PER_PAGE,
  TOAST_VARIANT,
} from "@root/constants";
import { MemberDetailsService } from "@root/services";
import { useTranslation } from "react-i18next";

export const useMemberDetails = () => {
  const { t } = useTranslation("common");
  const [memberData, setMemberData] = useState<any[]>([]);
  const [isMemberDataLoading, setIsMemberDataLoading] =
    useState<boolean>(false);
  const [isMemberHistoryLoading, setIsMemberHistoryLoading] =
    useState<boolean>(false);
  const [memberHistory, setMemberHistory] = useState<any[]>([]);
  const memberListDetailsService = new MemberDetailsService();
  const { showNotification } = useNotification();

  const [pageNo, setPageNo] = useState(1);
  const [count, setCount] = useState(0);
  const pageSize = RECORDS_PER_PAGE / 2;

  const payload = {
    offset: (pageNo - 1) * pageSize,
    limit: pageSize,
    status: JOURNALIST_COURSE_STATUS,
  };
  const fetchMemberDetails = async (id: number, payload?: any) => {
    setIsMemberDataLoading(true);
    try {
      const res = await memberListDetailsService.fetchMemberDetails(
        id,
        payload
      );
      setMemberData(res?.data?.data || []);
    } catch (error) {
      const message =
        error instanceof Error ? error.message : t("translate.dataLoadFailure");
      showNotification({
        type: TOAST_VARIANT.ERROR,
        message,
      });
    } finally {
      setIsMemberDataLoading(false);
    }
  };

  const fetchMemberHistory = async (id: number, payload?: any) => {
    setIsMemberHistoryLoading(true);
    try {
      const res = await memberListDetailsService.fetchMemberHistory(
        id,
        payload
      );
      setMemberHistory(res?.data?.data.rows || []);
      setCount(res?.data?.data?.count || []);
    } catch (error) {
      const message =
        error instanceof Error ? error.message : t("translate.dataLoadFailure");
      showNotification({
        type: TOAST_VARIANT.ERROR,
        message,
      });
    } finally {
      setIsMemberHistoryLoading(false);
    }
  };

  return {
    memberData,
    setMemberData,
    isMemberDataLoading,
    setIsMemberDataLoading,
    fetchMemberDetails,
    isMemberHistoryLoading,
    setIsMemberHistoryLoading,
    fetchMemberHistory,
    memberHistory,
    setMemberHistory,
    count,
    setCount,
    pageSize,
    pageNo,
    setPageNo,
  };
};
